<template>
  <div>
    <!--  头部模板  -->
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——地图导览</p>
      <div class="content">
        <div style="display: flex;text-align: left;">
          <div style="flex: 2;padding-top: 40px;">
            <h3 style="">联系我们</h3>
            <div style="margin-top: 20px;line-height: 35px;">
<!--              <p>电  话：024-48889088</p>-->
              <p>地  址：辽宁省本溪市桓仁满族自治县东关村10组</p>
              <p>邮  编：117200</p>
              <p>网  址：www.hsjyfwzx.com/#/yjj</p>
<!--              <p>邮  箱：Dnkryyj20180903@163.com</p>-->
            </div>

          </div>
          <div style="flex: 4">
            <baidu-map class='bm-view'
                       @ready="initMap"
                       :center="center"
                       :zoom="zoom"
                       :scroll-wheel-zoom="true"
                       style="border: 1px solid silver"

            ></baidu-map>
          </div>

        </div>

      </div>
    </div>
    <!--  底部模板  -->
    <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";

export default {
  name: "MapYjj",
  components:{
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{

      center: {      // 经纬度
        lng:125.383592,
        lat:41.281093
      },
      zoom: 100,
      BMap:null,      // 百度地图对象
      map:null,       // 百度地图实例
    }

  },
  methods:{
    initMap ({BMap, map}) {
      this.BMap = BMap ;
      this.map = map;
      var point = new BMap.Point(125.383592, 41.281093)
      // this.$set(this.center , 'lng' ,'需要传递的经纬度');
      // this.$set(this.center , 'lat' ,'需要传递的经纬度'  );
      map.centerAndZoom(point, 15);
      map.setCurrentCity('桓仁');


      var marker = new BMap.Marker(point);
      map.addOverlay(marker);



    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>

  .container{
    width:70%;
    margin: 0 auto;
    padding:10px 0;
  }
  .nav{
    text-align: left;
  }
  .content{

    margin-top: 20px;
  }
  .bm-view{
    width:100%;
    height:600px;
    margin-top: 50px;
    margin-bottom: 50px;
  }
</style>
